module.exports = {

    props:{
        user:{
            type: Object,
            required: true,
        }
    },

    data(){
        return {
            default_payment_method: null,
            payment_methods: [],
        }
    },

    created(){
        axios.get(`/billing/${this.user.slug}/payment-methods`).then(response => {
            this.payment_methods = response.data.payment_methods;
            this.default_payment_method = response.data.default;
        })
    },
}
